import { refreshExpirationDate } from '../actions/publicActions';
import { SharingData } from '../schema/SharingData';
import { SharingTipId } from '../types/sharingTipId';
import { logUsage } from 'owa-analytics';
import { InfoBarCustomAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import strings from 'owa-strings/owa-mail-strings';

export function getExpirationCustomActions(sharingData: SharingData): InfoBarCustomAction[] | null {
    const refreshCustomAction: InfoBarCustomAction = {
        text: strings.SuggestActionRefreshTheLink,
        action: () => {
            refreshExpirationDate(sharingData.id);
            logUsage('SharingTipsRefreshExpirationInfoBarClicked');
        },
    };
    const ignoreCustomAction: InfoBarCustomAction = {
        text: strings.SuggestActionIgnoreExpiration,
        action: () => {
            sharingData.sharingTipsIgnored.push(SharingTipId.linkHasExpired);
            sharingData.sharingTipsIgnored.push(SharingTipId.linkWillExpire);
            logUsage('SharingTipsIgnoreExpirationInfoBarClicked');
        },
    };
    return [refreshCustomAction, ignoreCustomAction];
}
